export const styles = theme => ({
    card: {
        height: 155,
        marginBottom: theme.spacing(4),
        marginRight: theme.spacing(4)
    },
    details: {
        marginTop: theme.spacing(4),
    },
    title: {
        margin: "2.5rem 0 1.5rem 0",
    },
    manageOrderTitle: {
        fontWeight: 600,
    },
    orderTitle: {
        margin: "1.5rem 0 1rem 0"
    },
    bold: {
        fontWeight: 900,
    },
    formControl: {
        margin: "1",
        minWidth: 150,
    },
    button: {
        margin: "10px",
    },
    buttonLeft: {
        marginTop: "10px",
        marginBottom: "10px",
        marginRight: "10px"
    },
    comment: {
        width: 500,
        marginTop: "1rem"
    },
    updateField: {
        width: 200,
    },
    updateFieldSmall: {
        width: 100,
    },
    tableRow: {
        height: 50
    },
    bottomMargin: {
        marginBottom: theme.spacing(2)
    },
    adornedEnd: {
        padding: "1px 10px"
    },
    link: {
        color: "#009",
        cursor: "pointer"
    },
    sectionTitle: {
        margin: "2.5rem 0 0.75rem 0",
        fontWeight: 600,
    }
});
